import { Button } from '@material-ui/core';
import React from 'react';
import { useHistory } from 'react-router';
import * as AuthSelectors from '../../../../redux/reducers/gl_auth_reducer/selectors';
import ModalActions from 'redux/reducers/gl_modal_reducer/actions';
import { ModalIDs } from 'redux/reducers/gl_modal_reducer/types';
import { useDispatch } from 'react-redux';
import CentralBankPaymentActions from '../../../../redux/reducers/payment_central_bank_reducer/actions';
import CentralBankPaymentStatus from 'config/centralBankPayments';
import useQuery from 'custom_hooks/useQuery';
import { TableDefaultFetchValues } from '../../configuration';
import NavigationConfig from 'navigation/config';
import * as CentralBankPaymentSelectors from '../../../../redux/reducers/payment_central_bank_reducer/selectors';
import useStyles from './styles';

interface IProps {
  id: number;
  statusCode: CentralBankPaymentStatus;
  amount: number;
  date: string;
  error: string;
}

export default function ActionsBlock(props: IProps) {
  const history = useHistory();
  const ROLE = AuthSelectors.useSelectUserRole();
  const dispatch = useDispatch();
  const classes = useStyles();
  const query = useQuery();
  const account = query.get('account');
  const statusCode = query.get('statusCode');
  const dateFrom = query.get('dateFrom');
  const dateTo = query.get('dateTo');
  const sortField: string = query.get('sortField')
    ? (query.get('sortField') as string)
    : TableDefaultFetchValues.TABLE_DEFAULT_SORT_KEY;
  const page: number = query.get('page')
    ? Number(query.get('page'))
    : TableDefaultFetchValues.TABLE_DEFAULT_PAGE;
  const pageSize: number = query.get('pageSize')
    ? Number(query.get('pageSize'))
    : TableDefaultFetchValues.TABLE_DEFAULT_PAGE_SIZE;
  const order: 'asc' | 'desc' = query.get('order')
    ? (query.get('order') as 'asc' | 'desc')
    : TableDefaultFetchValues.TABLE_DEFAULT_ORDER;

  // const paymentStatus =
  //   CentralBankPaymentSelectors.useUpdateCentralBankPaymentStatus();

  const handleClick = (type: 'N/A' | 'PIM') => {
    let statusCodeValue;
    switch (type) {
      case 'N/A': {
        statusCodeValue = CentralBankPaymentStatus.NOT_APPLICABLE;
        break;
      }
      case 'PIM': {
        statusCodeValue = CentralBankPaymentStatus.PIM_TO_BE_MATCHED;
        break;
      }
      default: {
        statusCodeValue = CentralBankPaymentStatus.NOT_APPLICABLE;
      }
    }
    dispatch(
      CentralBankPaymentActions.updateCentralBankPaymentStatus({
        id: props.id,
        statusCode: statusCodeValue,
        onSuccess: () => {
          dispatch(
            CentralBankPaymentActions.setCentralBankPaymentsAction({
              sortField: sortField,
              page: page,
              pageSize: pageSize,
              order: order,
              account: account,
              statusCode: statusCode,
              dateFrom: dateFrom,
              dateTo: dateTo,
            })
          );
        },
      })
    );
  };

  // React.useEffect(() => {
  //   if (paymentStatus && props.statusCode != paymentStatus) {
  //     console.log('payment status', paymentStatus);
  //     dispatch(
  //       CentralBankPaymentActions.setCentralBankPaymentsAction({
  //         sortField: sortField,
  //         page: page,
  //         pageSize: pageSize,
  //         order: order,
  //         account: account,
  //         statusCode: statusCode ? Number(statusCode) : null,
  //         dateFrom: dateFrom,
  //         dateTo: dateTo,
  //       })
  //     );
  //   }
  // }, [dispatch, paymentStatus]);

  let showErrorButton: boolean = true;
  if (props.error === null) showErrorButton = false;

  let showNAButton: boolean = false;
  if (
    props.statusCode == CentralBankPaymentStatus.NOT_MATCHED ||
    props.statusCode == CentralBankPaymentStatus.DIFFERENT_AMOUNT ||
    props.statusCode == CentralBankPaymentStatus.PIM_TO_BE_MATCHED ||
    props.statusCode == CentralBankPaymentStatus.POSSIBLE_DUPLICATE
  )
    showNAButton = true;

  let showMatchButton: boolean = false;
  if (
    props.statusCode == CentralBankPaymentStatus.NOT_MATCHED ||
    props.statusCode == CentralBankPaymentStatus.DIFFERENT_AMOUNT ||
    props.statusCode == CentralBankPaymentStatus.POSSIBLE_DUPLICATE
  )
    showMatchButton = true;

  const matchPayment = () => {
    dispatch(
      ModalActions.openModalAction({
        modalID: ModalIDs.MODAL_MATCH_CENTRAL_BANK_PAYMENT,
        params: {
          id: props.id,
          amount: props.amount,
          date: props.date,
        },
      })
    );
  };

  const showError = () => {
    dispatch(
      ModalActions.openModalAction({
        modalID: ModalIDs.MODAL_CENTRAL_BANK_PAYMENT_ERROR,
        params: {
          error: props.error,
        },
      })
    );
  };

  return (
    <div>
      {showNAButton && <Button onClick={() => handleClick('N/A')}>N/A</Button>}
      {props.statusCode == CentralBankPaymentStatus.NOT_MATCHED && (
        <Button onClick={() => handleClick('PIM')}>PIM</Button>
      )}
      {showMatchButton && <Button onClick={() => matchPayment()}>MATCH</Button>}
      {showErrorButton && (
        <Button onClick={() => showError()} className={classes.textRedColor}>
          ERROR
        </Button>
      )}
    </div>
  );
}
